import ARUGD_img from '../../assets/arugd.jpg';
import BLIP2_img from '../../assets/blip2.png';
import PALIGEMMA_img from '../../assets/paligemma.png';

// ===== Featured Projects ====
export const featuredProjects = [
  {
    id: 'arugd',
    title: 'Attention Res-Unet with Guided Decoder',
    image: ARUGD_img,
    orientation: 'left', // 'left' → Image | Content, 'right' → Content | Image
    link: 'https://www.sciencedirect.com/science/article/abs/pii/S1746809421006741?via%3Dihub',
    bullets: [
      'Designed a novel Guided Decoder mechanism to explicitly supervise intermediate decoder layers in U-Net–style models.',
      'Trained an end-to-end model combining Res-UNet and Attention gates with Guided Decoder, for semantic segmentation of brain tumors on the BraTS Dataset and achieved Dice Scores of 0.911, 0.876, and 0.801 across tumor sub-regions.',
      'Designed a weighted guided loss to improve prediction at each intermediate decoder layer.',
      'Published in the Biomedical Signal Processing and Control (2022) journal.',
    ],
    tags: ['Deep Learning', 'Semantic Segmentation', 'Biomedical Imaging'],
  },
  {
    id: 'blip-2',
    title: 'Vision-Language Modeling: BLIP-2',
    image: BLIP2_img,
    orientation: 'right',
    link: 'https://github.com/dhirajmaji7/VLM',
    bullets: [
      'Built a BLIP-2–style vision-language model (VLM) from scratch in PyTorch, integrating a ViT image encoder, Flan-T5 language model, and BERT-style Q-Former for image-conditioned generation and multimodal embedding alignment.',
      'Developed end-to-end training pipelines for image-text retrieval and captioning tasks on Flickr8k, implementing contrastive loss, image-text alignment loss, and language modeling loss, with custom tokenization, checkpointing, and W&B experiment tracking.',
      'Applied knowledge distillation to transfer ViT-L performance to a lightweight MobileNet, reducing model size and compute costs.',
    ],
    tags: ['VLM', 'Multimodal Generative models', 'Deep Learning'],
  },
  {
    id: 'paligemma',
    title: 'Optimized Multimodal Inference framework for PaliGemma VLM',
    image: PALIGEMMA_img,
    orientation: 'left',
    link: 'https://github.com/dhirajmaji7/paligemma',
    bullets: [
      'Implemented the PaliGemma Vision-Language Model (VLM) entirely from scratch, integrating the SigLIP vision encoder and Gemma language model into a unified multimodal transformer with prefix-LM masking, grouped/multi-query attention, rotary embeddings, and contrastive pretraining objectives for cross-modal alignment.',
      'Built a modular multimodal inference framework featuring KV cache optimization, top-p sampling, and weight tying between embedding and LM head layers — enabling efficient autoregressive text generation from image inputs and prompts.'
    ],
    tags: ['VLM', 'Inference Optimization', 'Multimodal Language models'],
  },
];

// ===== Other Projects =====
export const otherProjects = [
  {
    id: 'sr-gans',
    title: 'Super Resolution GANs',
    bullets: [
      'Implemented a Generative Adversarial Network (GAN) to upsample low-resolution images on Set5 and DIV2K datasets.',
      'Designed a custom loss with MSE, Adversarial loss and Perceptual loss achieving PSNR of 23.84 vs bicubic interpolation baseline.',
    ],
    tags: ['Generative Models', 'Deep Learning'],
  },
  {
    id: 'mobile-robot-slam',
    title: 'Autonomous Navigation of Mobile robots',
    bullets: [
      'Developed a Simultaneous Localization and Mapping (SLAM) algorithm for a mobile robot to create a map of its environment and localize its position using particle filters.',
      'Implemented A* path planning algorithm and autonomous exploration of an unknown environment.',
    ],
    tags: ['SLAM', 'Path Planning'],
  },
  {
    id: 'meta-md',
    title: 'Meta-Learning for End-to-End Molecular Dynamics Simulation',
    bullets: [
      'Developed a Deep Learning architecture for prediction of position and velocity states for 10,000 particles in a molecular system using dual-loop Meta-Learning-based approach.',
      'Designed the inner loop with unsupervised loss function to encode conservation laws of physics as inductive bias and a outer loop to supervise prediction of the next states of the particles.',
      'Achieved 85x speed boost compared to traditional Molecular Dynamic simulations.',
    ],
    tags: ['Meta-Learning', 'Deep Learning'],
  },
  {
    id: 'manipulator',
    title: 'Autonomous Pick and Place with Robotic Manipulator',
    bullets: [
      'Designed an algorithm for pose and color detection of blocks of varied dimensions using RGB-D cameras.',
      'Achieved a color detection accuracy of 98%, and a pose accuracy of 90% in a well lit environment',
      'Developed the kinematics model for a 5R manipulator for autonomous pick and place, and stacking operations.',
    ],
    tags: ['Computer Vision', 'Robot Kinematics'],
  },
  {
    id: 'vehicle-detection',
    title: 'Vehicle Detection on Kitti dataset',
    bullets: [
      'Designed a real-time object detection pipeline using YOLOv8 on the KITTI dataset, achieving 85.6% mAP@0.5 across cars, pedestrians, and cyclists.',
      'Optimized model inference with TensorRT Engine, reducing latency to 35 ms per frame (~30 FPS) for autonomous driving applications.',
    ],
    tags: ['Object Detection', 'Inference Optimization'],
  },
  {
    id: 'event-stereo',
    title: 'Event Camera based Stereo Depth Estimation',
    bullets: [
      'Designed a stereo depth estimation algorithm by back-projecting events from different viewpoints as 3D rays through a voxel grid.',
      'Implemented a ray-density based thresholding through each voxel to create local depth maps for each viewpoint, and the depth maps from multiple viewpoints are fused to create the final point cloud.',
    ],
    tags: ['Stereo Depth Estimation', 'Computer Vision'],
  }
];